import { endpoint } from '@library/endpoint'

import routes from 'config/routes'
import { fetch } from 'utils/fetch'

export function fetchShippingAddresses(accessToken) {
  return fetch(
    accessToken,
    `${endpoint('core')}${routes.core.userAddress}`,
    { type: 'shipping' },
    'GET',
  )
}
